import React, {useEffect, useState} from "react";
import {useSubheader} from "../../../_metronic/layout";
import {useTranslation} from "react-i18next";
import makeRequest from "../../api/makeRequest";
import {Checkbox, Paper, Table, TableBody, TableCell, TablePagination, TableRow} from "@material-ui/core";
import EnhancedTableHead from "../../components/EnhancedTableHead";
import moment from "moment-jalaali";
import {Link} from "react-router-dom";
import {Button, Dropdown} from "react-bootstrap";
import {DashboardFileMenu, DropdownCustomToggler} from "../../../_metronic/_partials/dropdowns";

export const FilesPage = () => {
  const { t } = useTranslation('common');
  const headRows = [
    {id: "id", disablePadding: true, label: t('Id')},
    {id: "name", disablePadding: true, label: t('Name')},
    {id: "url", disablePadding: true, label: t('Link')},
    {id: "size", disablePadding: true, label: t('Size')},
    {id: "mimeType", disablePadding: false, label: t('Type')},
    {id: "user", disablePadding: false, label: t('User')},
    {id: "room", disablePadding: false, label: t('RoomName')},
    {id: "operation", disablePadding: false, label: t('Operations')},
  ];
  const suhbeader = useSubheader();
  suhbeader.setTitle(t('Files'));

  const [selected, setSelected] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("id");
  const [order, setOrder] = React.useState("desc");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [totalDocs, setTotalDocs] = React.useState(0);

  const [Files, setFiles] = useState([])


  useEffect(() => {
    moment.loadPersian();

    const getFiles = async () => {
      try {
        const query = {
          page:page+1,
          per_page:rowsPerPage
        }
        const {data} = await makeRequest('getFiles', {},query)
        const files = data.files.docs
        setFiles(files)
        setTotalDocs(data.files.totalDocs)
      } catch (e) {
        console.log(e)
      }
    }

    getFiles()
  }, [page,rowsPerPage])

  function handleSelectAllClick(event) {
    if (event.target.checked) {
      const newSelecteds = Files.map(n => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  }

  function handleRequestSort(event, property) {
    const isDesc = orderBy === property && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(property);
  }


  function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
  }

  function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getSorting(order, orderBy) {
    return order === "desc"
      ? (a, b) => desc(a, b, orderBy)
      : (a, b) => -desc(a, b, orderBy);
  }

  const isSelected = name => selected.indexOf(name) !== -1;

  function handleClick(event, name) {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  }

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, Files.length - page * rowsPerPage);

  function handleChangePage(event, newPage) {
    setPage(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setPage(0)
    setRowsPerPage(parseInt(event.target.value, 10));
  }

  return (
    <>
      <div className="new-room">
        <Link to={'/file/new'}><Button variant="outline-primary mb-5">{t('MENU.NEW')}</Button></Link>
      </div>
      <Paper className={"classes.paper"}>
        <div className={"tableWrapper"}>
          <Table
            className={"classes.table"}
            aria-labelledby="tableTitle"
            size={"medium"}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={Files.length}
              headRows={headRows}
            />
            <TableBody>
              {stableSort(Files, getSorting(order, orderBy))
                .filter(q=>q.user)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      onClick={event => handleClick(event, row.id)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={isItemSelected}
                          inputProps={{
                            "aria-labelledby": labelId
                          }}
                        />
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        align="right"
                      >
                        {row.id}
                      </TableCell>
                      <TableCell align="right">{row.name}</TableCell>
                      <TableCell align="right"><a href={row.url} target="_blank">{t('View')}</a></TableCell>
                      <TableCell align="right">{(row.size / 1000).toFixed(2)}</TableCell>
                      <TableCell align="right">{row.mimeType}</TableCell>
                      <TableCell align="right">{row.user.name}</TableCell>
                      <TableCell align="right">{row.room.name}</TableCell>
                      <TableCell align="right">
                        <ItemDropdown item={row} onDelete={()=>{
                          setFiles(prev=>prev.filter(q=>q.id !== row.id))
                        }}/>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {/*{emptyRows > 0 && (
								<TableRow style={{height: 49 * emptyRows}}>
									<TableCell colSpan={6}/>
								</TableRow>
							)}*/}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          component="div"
          labelRowsPerPage={t('NumberPerPage')}
          count={totalDocs}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            "aria-label": "Previous Page"
          }}
          nextIconButtonProps={{
            "aria-label": "Next Page"
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </>
  );
};
const ItemDropdown = ({item,onDelete}) => {
  return (<>
    <Dropdown className="dropdown-inline" alignRight>
      <Dropdown.Toggle
        id="dropdown-toggle-top"
        as={DropdownCustomToggler}>
        <i className="ki ki-bold-more-hor"/>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
        <DashboardFileMenu item={item} onDelete={onDelete}/>
      </Dropdown.Menu>
    </Dropdown>
  </>);
};